// ==== CONSTANTES ====

export const SITUACOES = ['Enviado', 'Retentando', 'Pendente', 'Pausado', 'Erro']

export const CORES = [
  '#FF6384',
  '#36A2EB',
  '#FFCE56',
  '#4BC0C0',
  '#9966FF'
]

export const CORES_SITUACAO = {
  Enviado:    '#36A2EB',
  Retentando: '#FFCE56',
  Pendente:   '#9966FF',
  Pausado:    '#999999',
  Erro:       '#FF6384',
}

// ==== DATA HELPERS ====

export function formatarDataHoraBR(dataStr) {
  return new Date(dataStr).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit', month: '2-digit',
    hour: '2-digit', minute: '2-digit'
  })
}

export function converterData(dataStr) {
  return new Date(dataStr)
}

export function ehDeHoje(dataStr) {
  const data = new Date(dataStr)
  const hoje = new Date()

  return data.getUTCFullYear() === hoje.getUTCFullYear()
    && data.getUTCMonth() === hoje.getUTCMonth()
    && data.getUTCDate() === hoje.getUTCDate()
}

export function ehDaSemanaAtual(dataStr) {
  const data = new Date(dataStr)
  const hoje = new Date()

  const diaSemana = hoje.getUTCDay()
  const ajuste = diaSemana === 0 ? -6 : (1 - diaSemana)

  const inicioSemana = new Date(Date.UTC(
    hoje.getUTCFullYear(),
    hoje.getUTCMonth(),
    hoje.getUTCDate() + ajuste
  ))

  return data >= inicioSemana
}

// ==== PERIODOS ====

export const PERIODOS = {
  Semana: (data) => ehDaSemanaAtual(data),
  Hoje: (data) => ehDeHoje(data)
}

// ==== AGREGAÇÃO ====

export function contarSituacoes(envios) {
  const contagem = Object.fromEntries(SITUACOES.map(s => [s, 0]))

  for (const e of envios) {
    if (contagem[e.SituacaoEnvio] != null) {
      contagem[e.SituacaoEnvio]++
    }
  }

  return SITUACOES.map(s => contagem[s])
}

// ==== FORMATAÇÃO ====

export function formatarDataBR(dataStr) {
  const data = new Date(dataStr)

  const dia = String(data.getUTCDate()).padStart(2, '0')
  const mes = String(data.getUTCMonth() + 1).padStart(2, '0')

  return `${dia}/${mes}`
}